var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMapLocate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 14.094C0 6.33844 6.49174 0.0515332 14.5 0.0515332V0C22.5083 0 29 6.28691 29 14.0425V14.0682C29 14.5063 29 14.9443 28.9468 15.3565C28.7605 17.2375 28.2018 18.9896 27.3505 20.587C26.7119 21.7723 25.9138 22.8287 24.9826 23.782L21.8165 28.0334H21.7101V28.1623L15.1119 37L7.60917 28.0334L7.31651 27.6727L4.12385 23.8851C3.48532 23.2667 2.9266 22.5968 2.4211 21.8753C1.27706 20.2006 0.478899 18.2681 0.159633 16.1811C0.0532109 15.5111 0 14.8155 0 14.1198V14.094ZM14.5 17C16.9801 17 19 14.9801 19 12.5C19 10.0199 16.9801 8 14.5 8C12.0199 8 10 10.0199 10 12.5C10 14.9801 12.0199 17 14.5 17Z",
    fill: "#813DB5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapLocate);
export default __webpack_public_path__ + "static/media/icon_map_locate.33c81a269cdccf174ee41ec8d64aaa68.svg";
export { ForwardRef as ReactComponent };